import { Box } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import AdminTable from "./adminTable";
import SearchInput from "./project/searchInput";
import TableHistory from "./tableHistory";
import Tablemujahid from "./tablemujahid";

export default function Mujahids({ dataGroup }) {
  const [valueSearch, setValueSearch] = useState();
  const gridRef = useRef();
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  return (
    <>
      <Box mt="5px">
        <SearchInput
          type="text"
          id="filter-text-box"
          onInput={onFilterTextBoxChanged}
          value={valueSearch}
          onChange={(e) => setValueSearch(e.target.value)}
          mb="5px"
          mr="20px"
        />
        <AdminTable gridRef={gridRef} selected={3} dataGroup={dataGroup} />
      </Box>
    </>
  );
}
